import React from "react";
import { Container, MethodCount, Icon, MethodBody, GenericIconContainer } from "./ShowMoreCta.style";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";
import { useEffectOnce } from "@swiggy-private/core-ui";

// dls icons
import { default as Svg12 } from "@swiggy-private/dls-web-icons/dist/web/generic/chevronDown/12";

interface IShowMoreCta {
    handleClick: VoidFunction;
    dataTestId: string;
    methodCount?: string;
    icon?: boolean;
    text: string;
    onImpressionViewAll?: VoidFunction;
}

function ShowMoreCta({ handleClick, dataTestId, methodCount, icon, text, onImpressionViewAll }: IShowMoreCta) {
    useEffectOnce(() => {
        onImpressionViewAll && onImpressionViewAll();
    });

    return (
        <Container onClick={handleClick} data-testid={dataTestId}>
            {!isEmpty(methodCount) && (
                <MethodCount variant="V2.body1.neutral.bold" color="text_Button_Secondary">
                    {methodCount}
                </MethodCount>
            )}
            {icon && (
                <Icon>
                    <GenericIconContainer Icon={Svg12} fillColor="text_Button_Secondary" />
                </Icon>
            )}
            <MethodBody variant="V2.body1.neutral.bold" color="text_Button_Secondary">
                {text}
            </MethodBody>
        </Container>
    );
}

export default ShowMoreCta;
